
import React from "react";
import './about.css'
import Card from "react-bootstrap/Card";
import Sparck from "../Sparck/Sparck";
export default function About() {

  return (
    <div id='content-about'>
        <h1 id="about-title">About Idaka</h1>
        <p id="about-p">Idaka is a tool that provides two different approaches for retrieving/generating ML best practices: <br></br>1. an information retrieval (IR) engine  <br></br>2. a large language model.<br></br> The IR-engine uses BM25 as the algorithm for retrieving the practices, and a large language model, in our case Alpaca. The platform has been designed to allow comparative studies of best practices retrieval tools.  </p>
        <h3 id="team-title">Our team</h3>
        <div className="contenedor-team">
        <Card> <img
          src="Laura.png"
          onClick={() => {
          }}
          alt="Laura Helena Cabra-Acela"
          className="img-team"
        /> <Card.Body>
        <Card.Title>Laura Helena Cabra-Acela</Card.Title>
        <Card.Text>
        <small>lh.cabra@uniandes.edu.co</small>
        <dl>
        <dt>M.Sc Software Engineering Student, Universidad de los Andes, Colombia</dt>
  <dt>B.Sc Systems and Computing Engineering, Universidad de los Andes, Colombia</dt></dl></Card.Text>
      </Card.Body></Card>
        <Card> <img
          src="Ana.jpg"
          onClick={() => {
          }}
          alt="Anamaría Irmgard Mojica Hanke"
          className="img-team"
        /> <Card.Body>
        <Card.Title>Anamaría Irmgard Mojica-Hanke</Card.Title>
        <Card.Text>
        <small>mojica01@ads.uni-passau.de</small>
        <dl>
          <dt> Ph.D Computer Science Student,University of Passau, Germany </dt>
  <dt>M.Sc Information Engineering, Universidad de los Andes, Colombia</dt>
  <dt>B.Sc Systems and Computing Engineering, Universidad de los Andes, Colombia</dt></dl>
        

        </Card.Text>
      </Card.Body></Card>
      <Card> <img
          src="Mario.jpg"
          onClick={() => {
          }}
          alt="Mario Linares Vásquez"
          className="img-team"
        /> <Card.Body>
        <Card.Title>Mario Linares-Vásquez</Card.Title>
        <Card.Text>
        <small>m.linaresv@uniandes.edu.co</small>
        <dl>
  <dt>Associate Professor, Universidad de los Andes, Colombia</dt>
  <dt>Ph.D Computer Science, College of William and Mary, USA</dt>
<dt>M.Sc Systems and Computing Engineering, Universidad Nacional, Colombia</dt>        
<dt>B.Sc Systems and Computing Engineering, Universidad Nacional, Colombia</dt></dl>
        </Card.Text>
      </Card.Body></Card>
      <Card> <img
          src="Steffen.jpg"
          onClick={() => {
          }}
          alt="Steffen Herbold"
          className="img-team"
        /> <Card.Body>
        <Card.Title>Steffen Herbold</Card.Title>
        <Card.Text>
        <small>steffen.herbold@uni-passau.de</small>
        <dl>
  <dt>Associate Professor, University of Passau, Germany</dt>
  <dt>Habilitation Computer Science, Georg-August-Universität Göttingen, Germany</dt>    
  <dt>Ph.D Computer Science, Georg-August-Universität Göttingen, Germany</dt>    
<dt>M.Sc Applied Computer Science, Georg-August-Universität Göttingen, Germany</dt>  
<dt>B.Sc Applied Computer Science, Georg-August-Universität Göttingen, Germany</dt></dl>
</Card.Text>
      </Card.Body></Card>
        </div>
        
      <Sparck message='This is my team!' time={5000}></Sparck>
    </div>
  );
}
